import { useSmartLinkContext } from './state/context';
export function useFeatureFlag(featureFlag) {
  const {
    featureFlags
  } = useSmartLinkContext();
  return featureFlags && featureFlags[featureFlag];
}